export const getProgressColor = (percentage, text, isDark) => {
  if (percentage <= 20) {
    return text
      ? isDark
        ? "#f9e3e2"
        : "#752522"
      : isDark
      ? "#752522"
      : "#f9e3e2";
  } else if (percentage < 40) {
    return text
      ? isDark
        ? "#f8d8b0"
        : "#752522"
      : isDark
      ? "#752522"
      : "#f8d8b0";
  } else if (percentage < 60) {
    return text
      ? isDark
        ? "#fceed8"
        : "#73321B"
      : isDark
      ? "#73321B"
      : "#fceed8";
  } else if (percentage < 80) {
    return text
      ? isDark
        ? "#fef7ee"
        : "#b34a22"
      : isDark
      ? "#b34a22"
      : "#fef7ee";
  } else {
    return text
      ? isDark
        ? "#E6F7EA"
        : "#008241"
      : isDark
      ? "#008241"
      : "#E6F7EA";
  }
};

